/* Auto-inject the built CSS when the UMD/ES bundle or embedded build is loaded in a browser.
 * This ensures the player looks correct when embedded as a web component
 * without requiring the host page to manually include the CSS file.
 *
 * The injector determines the bundle's directory from the current script tag
 * and appends a <link rel="stylesheet"> to the corresponding CSS file in the same dir.
 * - Library builds (dist): injects `atunwa-player.css`
 * - Embedded build (embedded): injects `main.css`
 */
(function injectAtunwaStyles() {
  if (typeof document === 'undefined') return;
  const MARKER_ID = 'atunwa-player-css';
  if (document.getElementById(MARKER_ID)) return; // already injected

  // Find the script tag that loaded the library (ES/UMD) or embedded build (main.js)
  // We try document.currentScript first, then fall back to a heuristic search.
  const current = (document.currentScript as HTMLScriptElement | null);
  const candidates: HTMLScriptElement[] = [];
  if (current && current.src) candidates.push(current);
  candidates.push(
    ...Array.from(document.querySelectorAll('script[src]')).filter((s) => {
      const src = (s as HTMLScriptElement).src || '';
      return /atunwa-player\.(?:umd|es)\.js($|\?)/.test(src) || /my-lib\.(?:umd|es)\.js($|\?)/.test(src) || /\/main\.js($|\?)/.test(src);
    }) as HTMLScriptElement[]
  );

  let cssHref: string | null = null;
  for (const script of candidates) {
    try {
      const url = new URL(script.src, window.location.href);
      // Use the same directory as the script and point to our CSS filename
      const basePath = url.pathname.replace(/[^/]+$/, '');
      const file = (url.pathname.split('/').pop() || '').toLowerCase();
      const cssFile = /main\.js($|\?)/.test(file) ? 'main.css' : 'atunwa-player.css';
      cssHref = url.origin + basePath + cssFile;
      break;
    } catch {
      // ignore and continue
    }
  }

  // Only inject if we could determine a CSS URL from the script tag.
  if (!cssHref) return;

  const link = document.createElement('link');
  link.id = MARKER_ID;
  link.rel = 'stylesheet';
  link.href = cssHref;
  // Allow cross-origin if needed without blocking
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
})();
